function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "7fd24yhb0a",
  x1: "61.197%",
  x2: "26.108%",
  y1: "4.95%",
  y2: "71.926%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".657%",
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "26.01%",
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51.22%",
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "76.04%",
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleqavwkbb",
  x1: "107.63%",
  x2: "-130.552%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "40.87%",
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "77.54%",
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "lkurq02quc",
  x1: "86.243%",
  x2: "-50.129%",
  y1: "31.205%",
  y2: "134.664%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "xz2m0v4zbd",
  x1: "-18.811%",
  x2: "42.085%",
  y1: "-10.922%",
  y2: "35.304%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "6.85%",
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "47.62%",
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80.09%",
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00F076"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M130.961 40H5.04C2.262 40 0 37.746 0 35V5c0-2.756 2.262-5 5.039-5H130.96C133.736 0 136 2.244 136 5v30c0 2.746-2.264 5-5.039 5z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A6A6A6",
  d: "M130.961.8c2.33 0 4.236 1.888 4.236 4.2v30c0 2.312-1.894 4.2-4.236 4.2H5.04C2.709 39.2.803 37.312.803 35V5C.803 2.688 2.697.8 5.04.8H130.96zm0-.8H5.04C2.262 0 0 2.254 0 5v30c0 2.756 2.262 5 5.039 5H130.96c2.775 0 5.039-2.244 5.039-5V5c0-2.746-2.264-5-5.039-5z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M71.13 13c-.904 0-1.667-.294-2.27-.872-.598-.563-.931-1.338-.917-2.13 0-.844.31-1.559.917-2.126.6-.578 1.363-.872 2.268-.872.894 0 1.657.294 2.27.872.607.586.916 1.3.916 2.127-.01.847-.319 1.562-.917 2.126-.6.583-1.362.875-2.267.875zm-26.91 0c-.885 0-1.653-.29-2.28-.86-.624-.57-.94-1.29-.94-2.139 0-.85.316-1.569.94-2.138.615-.571 1.382-.86 2.28-.86.438 0 .864.08 1.272.245.401.16.728.377.97.643l.06.067-.676.615-.07-.076c-.38-.421-.892-.627-1.567-.627-.603 0-1.129.199-1.562.592-.436.396-.658.914-.658 1.541 0 .628.222 1.146.658 1.542.433.393.96.592 1.562.592.643 0 1.184-.2 1.605-.592.249-.232.403-.556.458-.965h-2.165v-.866H47.2l.013.079c.022.146.045.296.045.435 0 .798-.26 1.444-.773 1.92-.583.565-1.345.852-2.267.852zM80 12.877h-.954l-2.923-4.343.025.782v3.559h-.954v-5.75h1.089l.03.044 2.748 4.09-.025-.779V7.125H80v5.752zm-16.04 0h-.967V7.99h-1.677v-.865h4.318v.865h-1.677v4.887h.002zm-3.431 0h-.965V7.125h.965v5.752zm-5.42 0h-.964V7.99H52.47v-.865h4.317v.865H55.11v4.887zm-3.25-.009H48.16V7.125h3.697v.865h-2.73v1.578h2.464v.857h-2.465v1.578h2.731v.865zm17.709-1.335c.431.4.954.602 1.562.602.626 0 1.136-.197 1.562-.602.424-.393.638-.91.638-1.532s-.214-1.14-.635-1.532c-.431-.4-.957-.601-1.562-.601-.626 0-1.137.196-1.56.601-.424.394-.638.91-.638 1.532 0 .623.212 1.14.633 1.532z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M68.149 21.714c-2.364 0-4.28 1.784-4.28 4.245 0 2.439 1.928 4.246 4.28 4.246 2.363 0 4.28-1.797 4.28-4.246 0-2.461-1.917-4.245-4.28-4.245zm0 6.808c-1.294 0-2.407-1.065-2.407-2.573 0-1.53 1.116-2.573 2.407-2.573 1.293 0 2.406 1.043 2.406 2.573.002 1.518-1.113 2.573-2.406 2.573zm-9.338-6.808c-2.363 0-4.28 1.784-4.28 4.245 0 2.439 1.93 4.246 4.28 4.246 2.364 0 4.28-1.797 4.28-4.246 0-2.461-1.918-4.245-4.28-4.245zm0 6.808c-1.293 0-2.406-1.065-2.406-2.573 0-1.53 1.116-2.573 2.406-2.573 1.294 0 2.407 1.043 2.407 2.573 0 1.518-1.113 2.573-2.407 2.573zm-11.11-5.512v1.797h4.335c-.133 1.008-.468 1.752-.981 2.262-.635.632-1.616 1.32-3.344 1.32-2.664 0-4.748-2.141-4.748-4.792 0-2.65 2.084-4.79 4.748-4.79 1.438 0 2.486.565 3.264 1.286l1.28-1.274C51.176 17.79 49.738 17 47.722 17 44.067 17 41 19.961 41 23.587c0 3.636 3.064 6.588 6.72 6.588 1.974 0 3.455-.642 4.626-1.852 1.193-1.187 1.57-2.862 1.57-4.213 0-.42-.032-.799-.1-1.12h-6.118c.003-.002.003.02.003.02zm45.445 1.399c-.358-.953-1.438-2.705-3.654-2.705-2.196 0-4.022 1.72-4.022 4.245 0 2.384 1.806 4.246 4.234 4.246 1.951 0 3.087-1.187 3.555-1.884l-1.449-.966c-.48.71-1.148 1.175-2.096 1.175-.958 0-1.628-.433-2.073-1.287l5.705-2.351-.2-.473zm-5.818 1.418c-.045-1.64 1.28-2.473 2.229-2.473.748 0 1.37.365 1.583.898l-3.812 1.575zm-4.635 4.114h1.874V17.468h-1.874V29.94zm-3.076-7.284h-.068c-.422-.5-1.225-.953-2.25-.953-2.13 0-4.09 1.864-4.09 4.258 0 2.384 1.95 4.225 4.09 4.225 1.012 0 1.828-.455 2.25-.965h.068v.61c0 1.62-.87 2.493-2.274 2.493-1.148 0-1.86-.821-2.15-1.508l-1.63.677C74.033 32.614 75.28 34 77.342 34c2.196 0 4.057-1.287 4.057-4.425v-7.618h-1.771v.7h-.01zm-2.151 5.865c-1.293 0-2.374-1.075-2.374-2.56 0-1.499 1.08-2.584 2.374-2.584 1.28 0 2.273 1.098 2.273 2.584.013 1.485-.99 2.56-2.273 2.56zm24.452-11.054h-4.48V29.94h1.874v-4.723h2.608c2.074 0 4.113-1.496 4.113-3.87s-2.031-3.88-4.115-3.88zm.055 6.007h-2.664v-4.28h2.664c1.403 0 2.196 1.152 2.196 2.14 0 .978-.803 2.14-2.196 2.14zm11.568-1.784c-1.36 0-2.764.6-3.344 1.906l1.66.687c.359-.687 1.014-.92 1.707-.92.97 0 1.95.577 1.973 1.607v.132c-.335-.19-1.07-.478-1.95-.478-1.794 0-3.613.976-3.613 2.805 0 1.675 1.471 2.75 3.11 2.75 1.258 0 1.95-.565 2.383-1.22h.068v.966h1.806v-4.778c0-2.225-1.661-3.457-3.8-3.457zm-.235 6.831c-.613 0-1.47-.298-1.47-1.065 0-.965 1.07-1.331 1.983-1.331.825 0 1.216.177 1.706.42-.135 1.12-1.086 1.967-2.219 1.976zm10.623-6.565l-2.151 5.41h-.068l-2.228-5.41h-2.016l3.344 7.563-1.906 4.204h1.95L126 21.957h-2.071zm-16.863 7.984h1.873V17.468h-1.873V29.94z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#7fd24yhb0a)",
  d: "M10.459 7.067c-.291.311-.459.786-.459 1.408v22.062c0 .622.168 1.097.469 1.396l.077.067L23 19.64v-.277L10.536 7l-.077.067z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#gleqavwkbb)",
  d: "M27.068 25L23 20.652v-.304L27.068 16l.088.058 4.811 2.923c1.377.829 1.377 2.199 0 3.038l-4.811 2.923-.088.058z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#lkurq02quc)",
  d: "M27 24.267L22.7 20 10 32.599c.465.494 1.245.55 2.116.068L27 24.267",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#xz2m0v4zbd)",
  d: "M27 15.73L12.116 7.339c-.871-.494-1.654-.426-2.116.068L22.7 20l4.3-4.27z",
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M26.898 24l-14.782 8.502c-.826.481-1.562.448-2.037.01l-.079.08.079.07c.475.434 1.211.47 2.037-.01L27 24.091 26.898 24z",
  opacity: 0.2,
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M31.971 21.231L27 23.915l.09.085 4.869-2.632C32.657 20.99 33 20.494 33 20c-.042.454-.398.884-1.029 1.231z",
  opacity: 0.12,
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.525 7.489L31.96 18.687c.63.36.986.832 1.041 1.313 0-.527-.343-1.056-1.041-1.46L12.525 7.343C11.131 6.533 10 7.209 10 8.825v.146c0-1.618 1.13-2.281 2.525-1.482z",
  opacity: 0.25,
  transform: "translate(-722 -2354) translate(0 2034) translate(722 320)"
})))));

function SvgGooglePlayStoreBadgeEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStoreBadgeEn);
export default __webpack_public_path__ + "static/media/google-play-store-badge-en.9be904fa.svg";
export { ForwardRef as ReactComponent };